// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from '@/components/App'

import router from './router'

import scss from './assets/scss/main'

new Vue({
  el: '#app',
  router,  
  template: '<App/>',
  components: { App },
  mounted:function() {
    this.loaded()
  },
  methods:{
    loaded:function() {
      var el = document.querySelector(".js-hero-filter");

      setTimeout(function() {
        el.classList.add('hero-filter--opacity');
      }, 500);

    }
  },  
});



// WEBPACK FOOTER //
// ./src/main.js